import { Link } from "gatsby"
import React from "react"
import yolcu from "../assets/img/companys/01.png"
import cetmen from "../assets/img/companys/02.png"
import ecanta from "../assets/img/companys/03.png"
import enza from "../assets/img/companys/04.png"
import konfor from "../assets/img/companys/05.png"
import kuhne from "../assets/img/companys/06.png"
import matbuu from "../assets/img/companys/07.png"
import oracle from "../assets/img/companys/08.png"
import pakmaya from "../assets/img/companys/09.png"
import sefastone from "../assets/img/companys/11.png"
import yatas from "../assets/img/companys/12.png"
import ttgv from "../assets/img/companys/14.png"
import tcdd from "../assets/img/companys/15.png"
import liva from "../assets/img/companys/17.png"
import jll from "../assets/img/companys/18.png"
import arcelik from "../assets/img/companys/21.png"
import stm from "../assets/img/companys/22.png"
import havelsan from "../assets/img/companys/50.png"
import tanoto from "../assets/img/companys/26.png"
import cagdas from "../assets/img/companys/24.png"
import cumhurb from "../assets/img/companys/32.png"
import unwomen from "../assets/img/companys/31.png"
import toyota from "../assets/img/companys/toyota-logo.png"
import mehmetcik from "../assets/img/companys/mehmetcik_vakfi.png"
import pioli from "../assets/img/companys/pioli.png"
import fnss from "../assets/img/companys/fnss.png"
import akaliko from "../assets/img/companys/akaliko.png"
import inci from "../assets/img/companys/inci_aku.png"
import pinduk from "../assets/img/companys/ift_logo_flatart.webp"
import institut from "../assets/img/companys/pinduk_logo_flatart.webp"
import inciholding from "../assets/img/companys/inci_logo.webp"
import hills from "../assets/img/companys/referans-hillspet.png"

const Companys = () => (
  <div className="company-component">
    <div className="company-box">
      <img src={toyota} alt="Toyota" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={mehmetcik} alt="Mehmetçik Vakfı" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={arcelik} alt="Arçelik" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={yolcu} alt="Yolcu 360" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={enza} alt="Enza Home" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={tcdd} alt="TCDD Taşımacılık" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={unwomen} alt="UN Women" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={hills} alt="Hill's Pet Nutrition" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={konfor} alt="Konfor" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={kuhne} alt="Kühne" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={stm} alt="STM" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={oracle} alt="Oracle" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={inci} alt="İnci Akü" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={institut} alt="Institut Français" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={pinduk} alt="Pinduk" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={cetmen} alt="Çetmen" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={havelsan} alt="Havelsan" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={sefastone} alt="Sefa Stone" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={yatas} alt="Yataş Bedding" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={pakmaya} alt="Pakmaya" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={inciholding} alt="İnci Holding" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={ttgv} alt="TTGV" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={ecanta} alt="E-Çanta" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={liva} alt="Liva Pastacılık" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={jll} alt="JLL" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={cagdas} alt="Çağdaş" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={tanoto} alt="Tanoto" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={pioli} alt="Pioli" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={fnss} alt="FNSS" loading="lazy" />
    </div>
    <div className="company-box">
      <img src={akaliko} alt="Akaliko" loading="lazy" />
    </div>
  </div>
)

export default Companys
